//const {google} = require('googleapis');

const findLatLng = async (address) => {
    /*
    return await new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, (results, status) => {
            if (status === "OK") {
                const latitude = results[0].geometry.location.lat();
                const longitude = results[0].geometry.location.lng();

                resolve({lat: latitude, lng: longitude});
            } else {
                reject({error: `Geocode was not successful for the following reason: ${status}`})
            }
        });
    })
    */
}

export { findLatLng };
